export interface User {
  uid: string;
  email: string;
  displayName: string;
  /** Optional Firestore field; preferred over displayName when both exist (non-minister). */
  fullName?: string;
  /** Optional human-readable title from Firestore. */
  designation?: string;
  /** Profile photo URL (Firestore / Storage). */
  profileImage?: string;
  mobileNumber?: string;
  employeeId?: string;
  role: UserRole;
  departmentIds?: string[]; // Admin can map to multiple departments
  /** Block / NAC areas this user may access (master_locations names). */
  blockAccess?: string[];
  isActive: boolean;
  remarks?: string;
  createdAt: any;
  lastLogin?: any;
  // Role‑specific fields
  assignedDepartments?: string[]; // for operator & approver
  assignedSchemes?: string[]; // operator only
  assignedApproverIds?: string[]; // operator only
  assignedOperators?: string[]; // approver only
  approvalLevel?: string; // approver only, e.g., 'level1'
  approvalScope?: string; // approver only, e.g., 'single','multi'
  permissions?: Record<string, boolean>; // optional fine‑grained permissions
  assignedBy?: string;
  lastModifiedBy?: string;
  assignmentAudit?: UserAssignmentAuditEntry[];
}

export interface UserAssignmentAuditEntry {
  timestamp: unknown;
  action: 'created' | 'updated';
  assignedBy: string;
  departments: string[];
  blockAccess: string[];
  details?: string;
}

export enum UserRole {
  ADMIN = 'admin',
  OPERATOR = 'operator',
  APPROVER = 'approver',
  /** Honourable Minister — the seeded `minister@nimbletech.co.in` account. */
  MINISTER = 'minister',
  /** Officer on Special Duty — distinct from MINISTER but with same write authority. */
  OSD = 'osd'
}

export interface Department {
  id: string;
  name: string;
  isActive: boolean;
  createdAt: any;
  updatedAt?: any;
  history?: AuditLog[];
}

export interface Scheme {
  id: string;
  deptId: string;
  name: string;
  code: string;
  description: string;
  status: 'pending' | 'approved' | 'rejected' | 'inactive';
  remarks?: string;
  createdBy: string; // userId
  createdAt: any;
}

export interface ApprovalRequest {
  requestId: string;
  requestType: 'department' | 'scheme';
  targetId: string; // deptId or schemeId
  createdBy: string;
  approverId?: string;
  status: 'pending' | 'approved' | 'rejected';
  createdDate: any;
  approvedDate?: any;
  remarks?: string;
  data: any; // snapshot of data being requested
}

export interface AuditLog {
  timestamp: any;
  action: string;
  userId: string;
  details: string;
}

export interface LoginCredentials {
  email: string;
  password: string;
}
